
import common from '@/utils/common';
import * as Cookies from 'js-cookie';
export default {
  mixins: [common],
  props: {
    headerTitle: {
      type: String,
      default: '제목',
    },
  },
  data() {
    return {
      active: false,
      activeFinder: false,
      activeSidebar: false,
      activeSearch: false,
      activeDisSearch: false,
      container: {},
      searchingDistrict: {},
      form: {
        district: '',
        word: '',
      },
    };
  },

  methods: {
    handleActive() {
      this.active = !this.active;
      this.activeSearch = false;
    },
    setContainer(container) {
      this.container = container;
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },

    search() {
      window.location.href = '/posts?word=' + this.form.word;
    },
    changeDistrict(data) {
      if (data.district) this.searchingDistrict = data.district;
    },
    searchDis() {
      this.activeDisSearch = false;
      this.toDistrict(this.searchingDistrict);
    },

    toDistrict(district) {
      // if(!this.$auth.user)
      //     return this.$router.push("/auth/login");
      console.log(district, 22333333);
      if (district) {
        this.$store.commit('changeDistrict', district);
      } else {
        this.$store.commit('changeDistrict', {
          id: 0,
          district: '자유마을',
        });
        this.$router.push('/');
      }

      let route = this.$route.name;

      if (
        route === 'infos' ||
        route === 'staff' ||
        route === 'contacts' ||
        route === 'notices'
      ) {
        if (district) location.href = `/${route}`;
      } else if (route === 'index') {
        location.href = '/';
      }

      this.activeSidebar = false;
    },
    sideMenuToDistrict(district) {
      this.$store.commit('changeDistrict', district);
      location.href = '/';
    },

    toMain() {
      this.$store.commit('changeDistrict', {
        id: 0,
        district: '자유마을',
      });

      location.href = '/';

      this.activeSidebar = false;
    },
    async logout() {
      try {
        console.log(Cookies.get('auth_token'), '토큰');
        // 서버에 로그아웃 요청 (토큰 무효화가 필요한 경우)
        await this.$axios.post('/api/auth/logout', {
          headers: {
            Authorization: `Bearer ${Cookies.get('auth_token')}`,
          },
        });
        // 토큰 및 사용자 정보 삭제는 Nuxt Auth 라이브러리가 자동 처리함
        // 필요하면 명시적으로 초기화
        this.$auth.setUser(null);
        Cookies.set('auth_token', null, 0);

        // Flutter 연동이 있다면 postMessage 전송
        if (this.$store.state.isFlutter && window.logoutChannel) {
          window.logoutChannel.postMessage('logout');
        }

        // Vuex 상태 초기화
        this.$store.commit('changeDistrict', {
          id: 0,
          district: '자유마을',
        });
        this.$store.commit('setUserToken', null);

        // 로그아웃 후 리다이렉트(선택)
        this.$router.push('/auth/login');
      } catch (error) {
        console.error('Logout failed:', error);
        // 필요 시 에러 처리
      }
    },
  },

  computed: {
    district() {
      return this.$store.state.district;
    },
    activityArea() {
      return this.$store.state.activityArea;
    },
    myDistricts() {
      return this.$auth.user?.my_districts?.length > 0
        ? [
            ...this.$auth.user?.my_districts,
            this.activityArea.activity_id == this.$auth.user?.district.id
              ? null
              : {
                  ...this.activityArea,
                  id: this.activityArea.activity_id,
                  district: {
                    ...this.activityArea,
                    id: this.activityArea.activity_id,
                  },
                },
          ]
        : [
            this.activityArea.activity_id == this.$auth.user?.district.id
              ? null
              : {
                  ...this.activityArea,
                  id: this.activityArea.activity_id,
                  district: {
                    ...this.activityArea,
                    id: this.activityArea.activity_id,
                  },
                },
          ];
    },
  },

  async mounted() {
    await this.getActivityAreaInfo();
  },
};
